import { cva, type VariantProps } from 'class-variance-authority'
import type { ButtonHTMLAttributes } from 'react'

import { cn } from '../../lib/cn'

const variantesBoton = cva(
    'inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-400 disabled:pointer-events-none disabled:opacity-50',
    {
        variants: {
            variant: {
                default:
                    'bg-neutral-100 text-neutral-900 hover:bg-neutral-50 light:bg-sky-500 light:text-white light:hover:bg-sky-400',
                outline:
                    'border border-neutral-700 text-neutral-200 hover:bg-neutral-800 light:border-neutral-800 light:bg-white light:hover:bg-neutral-950',
                ghost: 'text-neutral-300 hover:bg-neutral-800 light:hover:bg-neutral-950',
            },
            size: {
                default: 'h-9 px-4 py-2',
                sm: 'h-8 px-3 text-xs',
            },
        },
        defaultVariants: { variant: 'default', size: 'default' },
    },
)

export interface PropsBoton
    extends ButtonHTMLAttributes<HTMLButtonElement>,
        VariantProps<typeof variantesBoton> {}

export function Button({ className, variant, size, ...props }: PropsBoton) {
    return <button className={cn(variantesBoton({ variant, size }), className)} {...props} />
}
